import { defineMessages, useIntl } from 'react-intl';
import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import cx from 'classnames';
import styles from '../styles.module.css';
import type { RootState } from './GeneralInfoSection';

export interface FormData {
  id: string;
  value: string;
  isRequired: boolean;
}

interface ThankYouPageProps {
  form_type: 'general_inquiries' | 'new_inquiries';
  formData?: FormData[];
}

const DataCell = ({
  id,
  value,
  data,
}: {
  id: string;
  value: string;
  data: RootState['contactFormInfo']['data'];
}) => {
  if (id === 'field-products') {
    if (Array.isArray(value)) {
      return value.map((product, index) => {
        if (index + 1 < value.length)
          return `${data.products.find((prod) => prod.token === product).title}, `;
        else return data.products.find((prod) => prod.token === product).title;
      });
    } else {
      return value;
    }
  } else if (id === 'countries')
    return data[id].find((c) => c.token === value)?.title || value;
  else return value;
};

const ThankYouPage = ({ form_type, formData }: ThankYouPageProps) => {
  const intl = useIntl();
  const useTypedSelector: TypedUseSelectorHook<RootState> =
    useSelector<RootState>;

  const { data } = useTypedSelector((state) => state.contactFormInfo);

  return (
    <div className={styles.thankYouPage}>
      <h2 className={styles.tyPageTitle}>
        {intl.formatMessage(messages.ty_title)}
      </h2>
      {form_type === 'general_inquiries' ? (
        <div className={styles.generalInquiriesTyPage}>
          <div className={styles.generalInquriesTyPageMessage}>
            {intl.formatMessage(messages.gen_inq_we_will_contact_you)}
          </div>
          <div className={styles.contactFormInfoTable}>
            {formData.map((field) => {
              console.log(field.id, intl.formatMessage({ id: field.id }));

              return (
                <div className={styles.tyPageTableRow} key={field.id}>
                  <div
                    className={cx(styles.tyPageCell, styles.tyPageHeadingCell)}
                  >
                    {intl.formatMessage({ id: field.id })}
                    {field.isRequired && ' (*)'}
                  </div>
                  <div className={styles.tyPageCell}>
                    <DataCell id={field.id} value={field.value} data={data} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className={styles.newInvestmentInquiriesTyPage}>
          <p>{intl.formatMessage(messages.new_inq_congrats_message)}</p>
          <p>{intl.formatMessage(messages.new_inq_follow_up)}</p>
          <p>{intl.formatMessage(messages.new_inq_check_email)}</p>
        </div>
      )}
    </div>
  );
};
export default ThankYouPage;

const messages = defineMessages({
  ty_title: {
    id: 'ty_title',
    defaultMessage: 'Thank you for your inquiry!',
  },
  gen_inq_we_will_contact_you: {
    id: 'gen_inq_we_will_contact_you',
    defaultMessage: 'We will contact you shortly.',
  },
  'field-products': {
    id: 'field-products',
    defaultMessage: 'Products of interest',
  },
  'privacy-policy_field_label': {
    id: 'privacy-policy_field_label',
    defaultMessage: 'Privacy Policy',
  },
  'privacy-marketing_field_label': {
    id: 'privacy-marketing_field_label',
    defaultMessage: 'Marketing purposes',
  },
  'privacy-data-analysis_field_label': {
    id: 'privacy-data-analysis_field_label',
    defaultMessage: 'Data analysis',
  },
  new_inq_congrats_message: {
    id: 'new_inq_congrats_message',
    defaultMessage:
      'Congratulations, you are one step closer to bringing your out of home entertainment vision to life!',
  },
  new_inq_follow_up: {
    id: 'new_inq_follow_up',
    defaultMessage:
      'A member of our team will be following up with you shortly to learn more about your project.',
  },
  new_inq_check_email: {
    id: 'new_inq_check_email',
    defaultMessage: 'Be sure to check your email.',
  },
});
